import { trans } from '@lingoda/i18n';
import { type SectionName } from '@lingoda/sections';
import { buildValidator } from '@lingoda/forms';
import { type PaymentMethodType } from '../../models';

export interface FormValues {
    paymentMethod?: string;
    name?: string;
    country?: string;
    paymentMethodType?: PaymentMethodType;
    section?: SectionName;
}

export const validate = (values: FormValues) => {
    const errors = buildValidator({
        paymentMethod: {
            required: trans('adyen-change-payment-method-subline', {}, 'student-common'),
        },
    })(values);

    return errors;
};
